import type { ReactNode } from 'react';
import clsx from 'clsx';
import { AppLink } from './AppLink';

export function TextLink({ href, className, children }: { href: string; className?: string; children: ReactNode }) {
  return (
    <AppLink href={href} className={clsx('tap font-semibold underline underline-offset-[3px]', className)}>
      {children}
    </AppLink>
  );
}
